import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const isTotalBelowMinimum = (totalMinutes: number) => {
  const current = dayjs();

  const hoursNeedPerDay = 7.5;

  const requiredMins: any = {
    Sunday: 0,
    Monday: 0,
    Tuesday: hoursNeedPerDay * 60,
    Wednesday: hoursNeedPerDay * 2 * 60,
    Thursday: hoursNeedPerDay * 3 * 60,
    Friday: hoursNeedPerDay * 4 * 60,
    Saturday: hoursNeedPerDay * 5 * 60,
  };

  const currentRequiredCount = requiredMins[current.format('dddd')];

  return Number(totalMinutes ?? 0) < currentRequiredCount;
};

const computeToday = (items: any[] | null | undefined, day: string) => {
  const today = (items ?? []).filter((item: any) => item.date === day);
  const todayTotal = today.reduce((acc: number, item: any) => acc + Number(item.minutes), 0);
  return { today, todayTotal };
};

export const weeklyLogsSlice = createSlice({
  name: 'weeklyLogs',
  initialState: {
    loading: false,
    data: null as any | null,
    today: null as any,
    todayTotal: 0,
    isBelow: false,
    currentDay: dayjs().format('YYYY-MM-DD'),
    error: null,
  },
  reducers: {
    getWeeklyLogs: () => {},
    // Background refetch used by WebSocket handlers: it reuses the same saga but must
    // NOT toggle `loading`, so the "Today"/"This week" totals and the timelog list keep
    // their current state (and scroll position) until the fresh data arrives.
    getWeeklyLogsSilent: () => {},
    setWeeklyLogsLoading: (state) => ({ ...state, loading: true, error: null }),
    setWeeklyLogsData: (state, action) => {
      const { today, todayTotal } = computeToday(action.payload?.data, state.currentDay);
      return {
        ...state,
        loading: false,
        data: action.payload,
        today,
        todayTotal,
        isBelow: action.payload ? isTotalBelowMinimum(action.payload?.meta?.total_minutes) : false,
      };
    },
    setCurrentDay: (state, action) => {
      const { today, todayTotal } = computeToday(state.data?.data, action.payload);
      return {
        ...state,
        currentDay: action.payload,
        today,
        todayTotal,
        isBelow: state.data ? isTotalBelowMinimum(state.data?.meta?.total_minutes) : false,
      };
    },
    setWeeklyLogsError: (state, action) => ({ ...state, loading: false, error: action.payload }),
  },
});

export const {
  setWeeklyLogsData,
  setCurrentDay,
  setWeeklyLogsError,
  setWeeklyLogsLoading,
  getWeeklyLogs,
  getWeeklyLogsSilent,
} = weeklyLogsSlice.actions;

export default weeklyLogsSlice.reducer;
